import * as R from 'ramda';

export const EstilosIndividuaisNomeColunasMarkup = R.cond([
  [R.equals("Codigo"), _ => ({textAlign: 'left'})],
  [R.equals("Descricao"), _ => ({textAlign: 'left'})],
  [R.equals("CodigoFabricante"), _ => ({textAlign: 'left'})],
  [R.equals("Unidade"), _ => ({})],
  [R.equals("MarkupMinimoPapelaria"), _ => ({textAlign: 'right'})],
  [R.equals("ValorMargemZeroPapelaria"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoAtualPapelaria"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupRealPapelaria"), _ => ({textAlign: 'right'})],
  [R.equals("CustoRealPapelaria"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupReal"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupRealSimples"), _ => ({textAlign: 'right'})], // 452507
  [R.equals("CustoReal1"), _ => ({textAlign: 'right'})],
  [R.equals("CustoAnterior"), _ => ({textAlign: 'right'})],
  [R.equals("CustoAtual"), _ => ({textAlign: 'right'})],
  [R.equals("CustoReal"), _ => ({textAlign: 'right'})],
  [R.equals("CustoUltimaPesquisa"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupUltimaPesquisa"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupPrecoVendaUltimaPesquisa"), _ => ({textAlign: 'right'})],
  [R.equals("MargemZeroUltPesquisa"), _ => ({textAlign: 'right'})], // 449132
  [R.equals("MargemLucro"), _ => ({textAlign: 'right'})],
  [R.equals("MargemLucroAnterior"), _ => ({textAlign: 'right'})],
  [R.equals("MargemLucroReal"), _ => ({textAlign: 'right'})],
  [R.equals("MargemLucroZeroPorMl"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupAnterior"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupMargemAtual"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupBruto"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupBrutoValorPresente"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupMargem"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupMargemPorMargem"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupMargemValorPresente"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupRealValorPresente"), _ => ({textAlign: 'right'})],
  [R.equals("MarkupRealPorMargem"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoAnterior"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoAtualValorPresente"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoCompra"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoCustoMl"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoLiquidoMl"), _ => ({textAlign: 'right'})],
  [R.equals("PrecoVendaMl"), _ => ({textAlign: 'right'})],
  [R.equals("Quantidade"), _ => ({textAlign: 'right'})],
])